export const defaultOutOfOfficeHeaderStyleProps = {
  generalStyleProps: {
    borderRadius: "0px",
    backgroundColor: "#000000",
    height: "40px"
  },
  titleStyleProps: {
    margin: "0 0 0 10px",
    color: "White"
  }
};